<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-2
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="bankAccStatus" @change="getBankAccList(true)" size="sm" :disabled="loading")
            option(value=0) {{ $t('ui.all') }}
            option(value=1) {{ $t('ui.active') }}
            option(value=-1) {{ $t('ui.inactive') }}
      .form-group.col-md-3.col-2
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.type') }}
          b-form-select(v-model="bankAccType" @change="getBankAccList(true)" size="sm" :disabled="loading")
            option(value="") {{ $t('ui.all') }}
            option(value="BOTH") {{ $t('ui.both') }}
            option(value="INCOMING") {{ $t('ui.incoming') }}
            option(value="OUTGOING") {{ $t('ui.outgoing') }}
      .form-group.col-xl-2.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getBankAccList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12(v-if="isEditAccess")
        b-button(v-b-modal.addBankAccount type="button" variant="info" size="sm" :disabled="loading")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_bank_account") }}
        b-button.ml-2(v-b-modal.bankTransfer type="button" variant="warning" size="sm" :disabled="loading")
          i.fas.fa-exchange-alt
          span.ml-1 {{ $t("ui.combine.bank_transfer") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12(style="max-height: 70vh; overflow: hidden;")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th.sortable(width="17%" @click="sortOrder('bank_acc_no')")
                  span.d-block(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                  span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                  .float-right
                    i(:class="changeSortKey('bank_acc_no')")
                  span.d-block(:title="$t('ui.bank_name')") {{ $t("ui.bank_name") }}
                //- th(width="8%")
                //-   span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                //- th.sortable(width="8%" @click="sortOrder('bank_acc_no')")
                //-   span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                //-   i(:class="changeSortKey('bank_acc_no')")
                //- th(width="8%")
                //-   span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                //- th(width="7%")
                //-   span(:title="$t('ui.type')") {{ $t("ui.type") }}
                th.text-right(width="7%")
                  span(:title="$t('ui.account_balance')") {{ $t("ui.short.account_balance") }}
                template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                  th.text-left(width="7%")
                    span(:title="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')") {{ ['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit') }}
                  th.text-left(width="7%" v-if="['AUD'].includes(getCurrencyCode)")
                    span(:title="$t('ui.payid')") {{ $t("ui.payid") }}
                th.text-center(width="7%")
                  span(:title="$t('ui.incoming_threshold')") {{ $t("ui.short.incoming_threshold") }}
                th.text-center(width="9%")
                  span(:title="$t('ui.incoming_frequency')") {{ $t("ui.short.incoming_frequency") }}
                th.text-center(width="9%")
                  span(:title="$t('ui.outgoing_threshold')") {{ $t("ui.short.outgoing_threshold") }}
                th.text-center(width="9%")
                  span(:title="$t('ui.outgoing_frequency')") {{ $t("ui.short.outgoing_frequency") }}
                th.text-center(width="6%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="9%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
            tbody.clusterize-content
              tr(v-if="bankAccountList.length == 0")
                td(:colspan="isEditAccess ? '15' : '14'").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in bankAccountList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span.small.d-block(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                  span.small.d-block(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
                  span.small.d-block(:title="item.bank_name + ' (' + item.bank_id + ')'") {{ item.bank_name }}
                  span.badge.badge-info(style="font-size:10px; padding:0.30rem !important;") {{ item.bank_acc_type }}
                //- td
                //-   span(:title="item.bank_acc_type") {{ item.bank_acc_type }}
                td.text-right
                  span.font-weight-bold(:title="$n(item.account_balance, 'currency')" :class="$helpers.fontClassName(item.account_balance)") {{ $n(item.account_balance, 'currency') }}
                template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                  td
                    span(:title="item.remark") {{ item.remark }}
                  td(v-if="['AUD'].includes(getCurrencyCode)")
                    span(:title="item.remark_2") {{ item.remark_2 }}
                td.text-center(
                  :class="{'red-bg': isShowAlert(item.accumulate_incoming_amount, item.incoming_amount_threshold) && item.bank_acc_type.toUpperCase() != 'OUTGOING'}"
                  )
                  span(v-if="item.bank_acc_type.toUpperCase() == 'OUTGOING'") -
                  span(v-if="item.bank_acc_type.toUpperCase() != 'OUTGOING'" :title="$n(item.accumulate_incoming_amount, 'currency')") {{ $n(item.accumulate_incoming_amount, 'currency') }}
                  hr(v-if="item.bank_acc_type.toUpperCase() != 'OUTGOING'")
                  span(v-if="item.bank_acc_type.toUpperCase() != 'OUTGOING'" :title="$n(item.incoming_amount_threshold, 'currency')") {{ $n(item.incoming_amount_threshold, 'currency') }}
                td.text-center(
                  :class="{'red-bg': isShowAlert(item.accumulate_incoming_frequency, item.incoming_frequency_threshold) && item.bank_acc_type.toUpperCase() != 'OUTGOING'}"
                  )
                  span(v-if="item.bank_acc_type.toUpperCase() == 'OUTGOING'") -
                  span(v-if="item.bank_acc_type.toUpperCase() != 'OUTGOING'" :title="$n(item.accumulate_incoming_frequency, 'currency')") {{ $n(item.accumulate_incoming_frequency, 'currency')  }}
                  hr(v-if="item.bank_acc_type.toUpperCase() != 'OUTGOING'")
                  span(v-if="item.bank_acc_type.toUpperCase() != 'OUTGOING'" :title="$n(item.incoming_frequency_threshold, 'currency')") {{ $n(item.incoming_frequency_threshold, 'currency') }}
                td.text-center(
                  :class="{'red-bg': isShowAlert(item.accumulate_outgoing_amount, item.outgoing_amount_threshold) && item.bank_acc_type.toUpperCase() != 'INCOMING'}"
                  )
                  span(v-if="item.bank_acc_type.toUpperCase() == 'INCOMING'") -
                  span(v-if="item.bank_acc_type.toUpperCase() != 'INCOMING'" :title="$n(item.accumulate_outgoing_amount, 'currency')") {{ $n(item.accumulate_outgoing_amount, 'currency') }}
                  hr(v-if="item.bank_acc_type.toUpperCase() != 'INCOMING'")
                  span(v-if="item.bank_acc_type.toUpperCase() != 'INCOMING'" :title="$n(item.outgoing_amount_threshold, 'currency')") {{ $n(item.outgoing_amount_threshold, 'currency') }}
                td.text-center(
                  :class="{'red-bg': isShowAlert(item.accumulate_outgoing_frequency, item.outgoing_frequency_threshold) && item.bank_acc_type.toUpperCase() != 'INCOMING'}"
                  )
                  span(v-if="item.bank_acc_type.toUpperCase() == 'INCOMING'") -
                  span(v-if="item.bank_acc_type.toUpperCase() != 'INCOMING'" :title="$n(item.accumulate_outgoing_frequency, 'currency')" ) {{ $n(item.accumulate_outgoing_frequency, 'currency')  }}
                  hr(v-if="item.bank_acc_type.toUpperCase() != 'INCOMING'")
                  span(v-if="item.bank_acc_type.toUpperCase() != 'INCOMING'" :title="$n(item.outgoing_frequency_threshold, 'currency')") {{ $n(item.outgoing_frequency_threshold, 'currency')  }}
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' :disabled="!isEditAccess" v-model="item.status" @change="changedBankAccStatus(item, $event)")
                      span.custom-switch-indicator
                td.text-center.actions(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                  span.ml-1
                    a.fa.fa-sync.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onReset(item)" :title="$t('ui.reset_threshold')")
                  span.ml-1
                    a.fa.fa-sliders-h.btn.btn-ssm.btn-icon.btn-info(href="javascript:void(0)" @click="onAdjust(item)" :title="$t('ui.adjust_balance')")
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
  addbankaccount(@clicked="addBankAccount" @failed="handleFailed")
  //- editbanksetting(@clicked="editBankSetting" @failed="handleFailed")
  editbankaccount(ref="editbankaccount" :item="editSelectedBankAccount" @clicked="afterEditBankAccount" @failed="handleFailed")
  resetthreshold(ref="resetthreshold" :item="editSelectedBankAccount" @clicked="afterResetThreshold" @failed="handleFailed")
  banktransfer(ref="banktransfer" @clicked="afterBankTransfer" @failed="handleFailed")
  bankadjust(ref="bankadjust" :item="editSelectedBankAccount" @clicked="afterBankAdjust" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addbankaccount from "@/components/payment/addBankAccount.vue";
import editbankaccount from "@/components/payment/editBankAccount.vue";
import resetthreshold from "@/components/payment/resetThreshold.vue";
// import editbanksetting from "@/components/bank/editBankSetting.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import banktransfer from "@/components/payment/bankTransfer.vue";
import bankadjust from "@/components/payment/bankAdjust.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addbankaccount,
    editbankaccount,
    resetthreshold,
    // editbanksetting,
    banktransfer,
    bankadjust
  },
  data: () => ({
    loading: false,
    bankAccountList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "bank_acc_no",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBankAccount: null,
    bankAccStatus: 1,
    bankAccType : ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeBank;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_bank");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {  },
  methods: {
    refresh() {
      this.getBankAccList(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getBankAccList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    isShowAlert(accumulate, threshold) {
      if (threshold <= 0) {
        return false;
      } else {
        if (parseFloat(accumulate) >= parseFloat(threshold))
          return true;
      }

      return false;
    },
    afterEditBankAccount: function(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_bank_account"), this.$t("message.success"), "success");
    },
    afterResetThreshold: function(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.combine.reset_threshold"), this.$t("message.success"), "success");
    },
    afterBankTransfer: function(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.combine.bank_transfer"), this.$t("message.success"), "success");
    },
    afterBankAdjust: function(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.combine.bank_adjust"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedBankAccount = e;
      this.$refs.editbankaccount.$refs.editBankAccount.show();
    },
    onReset(e) {
      this.editSelectedBankAccount = e;
      this.$refs.resetthreshold.$refs.resetThreshold.show();
    },
    onAdjust(e) {
      this.editSelectedBankAccount = e;
      this.$refs.bankadjust.$refs.bankAdjust.show();
    },
    getBankAccList: function(isSearch) {
      let url = config.bankListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.bankAccType.trim() != '')
        json.bank_acc_type = this.bankAccType;

      if (this.bankAccStatus == 1) {
        json.bank_status = true;
      } else if (this.bankAccStatus == -1) {
        json.bank_status = false;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bankAccountList = response.data.dt;
                this.totalRow = this.bankAccountList.length > 0 ? this.bankAccountList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedBankAccStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_bank_account_status_confirm", { name: item.bank_acc_no }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBankAccStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmBankAccStatus: function(item, status) {
      let url = config.bankStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        bank_id: item.bank_id,
        bank_acc_no: item.bank_acc_no,
        new_status: status,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getBankAccList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getBankAccList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    editBankSetting: function() {
      this.$helpers.showDialog(this.$t("ui.combine.configure_bank_setting"), this.$t("message.success"), "success");
    },
    addBankAccount: function() {
      this.getBankAccList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_bank_account"), this.$t("message.success"), "success");
    },
    edit: function(item) {
      this.bankAccountList.filter(function(info) {
        if (info.account_id == item.account_id) {
          info.full_name = item.full_name;
          info.contact_phone = item.contact_phone;
          info.contact_email = item.contact_email;
          info.dob = item.dob;
          info.mail_address = item.mail_address;
        }
      });

      this.$helpers.showDialog(this.$t("ui.combine.edit_bank_account"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeBank", pageSize);
      this.currentPage = 1;
      this.getBankAccList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getBankAccList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
hr {
  margin-top:0em !important;
  margin-bottom:0em !important;
  width: 50% !important;
}

.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

.red-bg {
  background-color: lightcoral !important;
  color: #000
}

td {
  vertical-align: middle !important;
}
</style>